<template>
  <div class="ba-container ba-gp-1 ba-ai-baseline ba-w-100 ba-grid">
    <!-- <nav-component :newSiteModal="true"></nav-component> -->

    <Breadcrumbs />
    <builderall-loader :loading="loadingAll" class='ba-card'>
      <div class='ba-flex ba-jc-sb ba-ai-center ba-w-100'>
        <span class='ba-title'>Tags</span>
        <div class='ba-box-items ba-flex ba-gp-1'>
          <button class='ba-btn ba-md ba-blue' @click.prevent="$refs.addTagGroup.open()" v-if="!editing.status">
            <builderall-icon code='2780'></builderall-icon>
            {{ $t('ct-new-group') }}
          </button>
          <template v-if="editing.status">
            <button class="ba-btn ba-md ba-light" type="button" @click.prevent="editing.status = false">{{
              $t('ct-cancel') }}</button>
            <button class="ba-btn ba-md ba-green" type="button" @click.prevent="saveGroup(editing.group)"><i
                class="svg-icon svgi-save"></i>{{ $t('ct-save-tag-group') }}
            </button>
            <button class="ba-btn ba-md ba-red" type="button" @click.prevent="modalDeleteGroup(group)"><i
                class="svg-icon svgi-delete svgi-light"></i> {{ $t('ct-delete') }}</button>
          </template>
        </div>
      </div>
      <br>
      <hr class='ba-hr-row'>
      <br>
      <div class='ba-content ba-w-100'>
        <div v-if="editing.status">
          <tags-item-component :group="editing.group" v-if="editing.group" :tags="tags"
            custom_class="ba-grid ba-gp-1"></tags-item-component>
          <div class="ba-flex ba-jc-fe my-4">
            <button class="ba-btn ba-md ba-light mr-2" type="button" @click.prevent="editing.status = false">{{
              $t('ct-cancel') }}</button>
            <button class="ba-btn ba-md ba-green" type="button" @click.prevent="saveGroup(editing.group)"><i
                class="svg-icon svgi-save"></i>{{ $t('ct-save-tag-group') }}
            </button>
          </div>
        </div>
        <table v-else-if="groups && groups.length > 0" class='ba-table ba-lines-all ba-md ba-w-100'>
          <thead>
            <tr>
              <th>{{ $t('ct-name') }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(group, index) in groups" v-bind:key="index">
              <td><p>{{ `${group.name}` }}</p></td>
              <td class="ba-flex ba-jc-fe ba-gp-1">
                <button ba-tooltip-position='top' 
                  :ba-tooltip-title="$t('ct-edit')" class='ba-btn ba-btn-normal ba-sm ba-rounded' @click.prevent="editGroup(group)" >
                  <builderall-icon code='edit' />
                </button>
                <button ba-tooltip-position='top' 
                  :ba-tooltip-title="$t('ct-delete')" class='ba-btn ba-btn-trash ba-sm ba-rounded' @click.prevent="modalDeleteGroup(group)">
                  <builderall-icon code='trash' />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else>
          <builderall-empty-image />
        </div>
      </div>
    </builderall-loader>

    <!-- CREATE TAG GROUP -->
    <sweet-modal ref="addTagGroup" width="60vw" hide-close-button>
      <div class="ba-flex ba-ai-center ba-jc-sb ba-mg-b-1">
        <h5 class="ba-color-blue1">{{ $t('ct-create-group') }}</h5>
        <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click="$refs.addTagGroup.close()">
          <builderall-icon code='64f7' />
        </button>
      </div>
      <hr class='ba-hr-row'>
      <div class="ba-grid ba-mg-y-1">
        <label for="name-group" class="ba-custom-label">{{ $t('ct-name') }}</label>
        <input type="text" id="name-group" required="required" class="ba-input ba-md ba-w-100"
          v-model="newGroup.name" />
      </div>
      <div class="ba-flex ba-ai-center ba-jc-fe ba-gp-1">
        <button slot="button" class="ba-btn ba-md ba-light" @click.prevent="$refs.addTagGroup.close()">{{
          $t('ct-cancel')}}</button>
        <button slot="button" class="ba-btn ba-md ba-blue" @click.prevent="createTagGroup(newGroup)">{{ $t('ct-save')
          }}</button>
      </div>
    </sweet-modal>

    <!-- CREATE TAG -->
    <sweet-modal ref="addTag" width="50vw">
      <h3 class="mb-5">{{ $t('ct-create-tag') }}</h3>
      <div class="form-group">
        <label for="tag-name">{{ $t('ct-name') }}</label>
        <input type="text" id="tag-name" required="required" class="form-control form-control-line"
          v-model="newTag.name" />
      </div>
      <div class="form-group">
        <label for="tag-value">{{ $t('ct-value') }}</label>
        <input type="text" id="tag-value" required="required" class="form-control form-control-line"
          v-model="newTag.value" />
      </div>
      <div class="form-group">
        <label for="tag-description">{{ $t('ct-description') }}</label>
        <input type="text" id="tag-description" required="required" class="form-control form-control-line"
          v-model="newTag.description" />
      </div>
      <div class="form-group">
        <label for="tag-example">{{ $t('ct-example') }}</label>
        <input type="text" id="tag-example" required="required" class="form-control form-control-line"
          v-model="newTag.example" />
      </div>
      <button slot="button" class="btn btn-outline-light" @click.prevent="$refs.addTag.close()">{{ $t('ct-cancel')
        }}</button>
      <button slot="button" class="btn btn-outline-primary" @click.prevent="createTag()"><i
          class="svg-icon svgi-save"></i>{{ $t('ct-save') }}</button>
    </sweet-modal>

    <modal-delete-component :show="modal.delete.show" :values="modal.delete.config" @cancel="cancelModalDelete()"
      @exclude="deleteGroup"></modal-delete-component>

  </div>
</template>

<script>
import NavComponent from './layout/nav/Nav.vue';
import BreadcrumbComponent from './components/Breadcrumb';
import { getTags, getGroups, storeUserTags, storeGroup, deleteGroup as deleteGrouTag } from '../../js/services/editor/autotag';
import { SweetModal } from 'sweet-modal-vue';
import ModalDeleteComponent from './components/ModalDelete';
import TagsItemComponent from './components/TagsItem';
import Breadcrumbs from '../general/Breadcrumbs.vue';

export default {
  name: 'Tags',
  components: {
    NavComponent,
    BreadcrumbComponent,
    SweetModal,
    ModalDeleteComponent,
    TagsItemComponent,
    Breadcrumbs
  },
  data() {
    return {
      groups: [],
      tags: [],
      modal: {
        delete: {
          show: false,
          config: ''
        }
      },
      indexGroup: 0,
      newGroup: {
        name: '',
        tags: []
      },
      newTag: {},
      editing: {
        status: false,
        group: false
      },
      loadingAll: false
    };
  },
  methods: {
    getUserGroups() {
      let vm = this;
      this.loadingAll = true;
      getTags()
        .then((res) => {
          vm.tags = res.data;
        })
        .finally(() => {
          this.loadingAll = false;
        });
      getGroups()
        .then((res) => {
          vm.groups = res.data;
        })
        .finally(() => {
          this.loadingAll = false;
        });
    },

    clearEditGroup() {
      this.editing = {
        status: false,
        group: false
      };
    },

    editGroup(group) {
      this.editing = {
        status: true,
        group: group
      };
    },

    modalDeleteGroup(group) {
      this.modal.delete.show = true;
      this.modal.delete.config = group;
    },

    cancelModalDelete() {
      this.modal.delete.show = false;
    },

    deleteGroup(group) {
      let vm = this;
      this.loadingAll = true;

      deleteGrouTag(group.id)
        .then((res) => {
          let data = res.data;

          if (data.success) {
            this.clearEditGroup();
            vm.getUserGroups();

            this.$snotify.success(
              this.$t('ct-tag-group-deleted')
            );
          } else {
            this.$snotify.error(
              this.$t('ct-tag-group-not-deleted')
            );
          }
        })
        .catch(error => console.warn(error))
        .finally(() => {
          this.loadingAll = false;
        });

      this.modal.delete.show = false;
    },

    saveGroup(group) {
      this.loadingAll = true;

      storeUserTags(group)
        .then(res => {
          this.$snotify.success(this.$t('ct-tag-group-saved'));
          this.clearEditGroup();
        })
        .finally(() => {
          this.loadingAll = false;
        });
    },

    saveAllGroup(group) {
      let vm = this;
      this.groups.forEach(group => {
        vm.saveGroup(group);
      });
    },

    createTagGroup(group) {
      let vm = this;
      this.loadingAll = true;

      storeGroup(group)
        .then(res => {
          vm.getUserGroups();
          vm.newGroup.name = '';
          this.$snotify.success(
            this.$t('ct-tag-group-created')
          );
        })
        .finally(() => {
          this.loadingAll = false;
        });

      this.$refs.addTagGroup.close();
    },
    openModalCreateTag(index) {
      this.indexGroup = index;
      this.$refs.addTag.open();
    },
    createTag() {
      const { name, value, description, example } = this.newTag;

      this.tags[this.indexGroup].tags.push({
        name,
        value,
        description,
        example
      });

      this.newTag = {};
      this.$refs.addTag.close();
    }
  },
  created() {
    this.getUserGroups();
  }
};
</script>
<style lang="scss" scoped>
.group-tags-desc {
  color: #5a5959;
  font-size: 16px;
  margin-left: .25rem;
}

.card-tags-group {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: end;
  min-height: 80px;

  .card-header {
    font-size: 18px;
    color: #5a5959;
    border: none !important;
    flex: 1;
  }

  .card-body {
    text-align: right;
    padding: .75rem;
    flex: none;
    border: none
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Tags.vue